import { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

// Subtle vertical parallax for large LIFESTYLE photos only.
// Disabled on mobile and when the user prefers reduced motion.
export default function ParallaxImage({ src, alt = "", className = "", amount = 8, focus = "center" }) {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const update = () => setEnabled(mq.matches && !reduced);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, [reduced]);

  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${amount}%`, `${amount}%`]);

  const style = { objectPosition: focus };
  if (enabled) style.y = y;

  return (
    <div ref={ref} className="relative h-full w-full overflow-hidden">
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        style={style}
        className={`absolute left-0 top-[-15%] h-[130%] w-full object-cover ${className}`}
      />
    </div>
  );
}
